const Topbar = () => {
  return (
    <div className="bg-lightbrown text-ink">
      <div className="mx-auto max-w-7xl py-2 px-6">
        <div className="text-xs sm:text-sm text-center">
          Spend IDR1.500.000+ and enjoy 5% OFF at checkout.
        </div>
      </div>
    </div>
  );
};

export default Topbar;
